module.exports = __webpack_public_path__ + "img/logo.50383df3.png";